/**
 * Ce qui recouvre la page — fenêtres, panneaux ancrés.
 *
 * Le bouton flottant « Créer » restait par-dessus : il masquait le bouton
 * « Commander » d'une fenêtre et les derniers statuts du panneau d'un chantier.
 * Tant qu'un recouvrement est ouvert, `data-recouvert` est posé sur le corps de
 * la page, et le bouton flottant s'efface (voir `index.css`).
 *
 * Un compteur plutôt qu'un booléen : une confirmation s'ouvre par-dessus une
 * commande, et fermer la première ne doit pas faire revenir le bouton.
 */
let ouverts = 0;

export function retenirRecouvrement(): () => void {
  ouverts += 1;
  document.body.dataset.recouvert = "";
  let rendu = false;
  return () => {
    if (rendu) return;
    rendu = true;
    ouverts = Math.max(0, ouverts - 1);
    if (ouverts === 0) delete document.body.dataset.recouvert;
  };
}
